import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from '../common-data-model';

@Component({
  selector: 'app-order-excess-value-form',
  templateUrl: './order-excess-value-form.component.html',
  styleUrls: ['./order-excess-value-form.component.scss']
})
export class OrderExcessValueFormComponent implements OnInit {

  commonData = new CommonDataModel();
  statusUpdateModel = this.commonData.orderExcessValueModel;
  excessValue: any;
  isFormLoading = false;
  statusList = this.commonData.orderExcessValueStatusModel;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<OrderExcessValueFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private toastr: ToastrService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.excessValue = this.data;
    if (this.excessValue) {
      this.statusUpdateModel.orderId = this.excessValue.orderId;
      this.statusUpdateModel.statusId = this.excessValue.excessValueStatusId;
    }
  }


  onSave() {
    this.isFormLoading = true;
    this.commonService.updateOrderExcessValue(this.statusUpdateModel)
    .pipe(finalize(() => (this.isFormLoading = false)))
    .subscribe((response: any) => {
      this.isFormLoading = false;
      if (response.isSuccess) {
        const sendingData = {
          confirmResult: true
        };
        this.dialogRef.close(sendingData);
        this.toastr.success(response.errors || 'Status update successfully');
      } else {
        this.dialogRef.close();
        this.toastr.error(response.errors || 'Something Went wrong, Please Re-try.', 'Error!');
      }
    });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
